@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .root {
    display: grid;

    // auto-fit: fewer items than itemsPerRow expand equally (e.g. 2 → 50/50);
    // full or overflow rows cap at itemsPerRow columns (e.g. 5 with 4/row → last tile stays ¼ width).
    grid-template-columns: repeat(
      auto-fit,
      minmax(
         calc(
            (100% - (var(--key-stats-items-per-row) - 1) * 12px) / var(--key-stats-items-per-row)
          ),
        1fr
      )
    );
    gap: 12px;
  }

  .tileCard {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    padding: 12px;
    border: 1px solid var(--border-soft);
    @include border-radius-r2;
  }

  .tileLabel {
    @include typography-v2-body-sm;
    color: var(--text-soft);
  }

  .tileValue {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    @include typography-v2-body-base;

  }

  .bullish {
    @include typography-v2-body-xs;
    color: var(--viz-bullish);
  }

  .bearish {
    @include typography-v2-body-xs;
    color: var(--viz-bearish);
  }
}
